<template>
  <div class="log-item-detail">
    <p>ID <code>{{modelValue._id}}</code></p>
    <p>ID utente <code>user_id</code>: <a :class="`cursor-pointer${isChanged('user_id') ? ' font-weight-bold':''}`" @click="$router.push(`/users/${modelValue.user_id}`)">{{displayUserId(modelValue.user_id)}}</a></p>
    <p>Consumabile <code>consumable</code>: <span :class="`${isChanged('consumable') ? ' font-weight-bold':''}`">{{modelValue.consumable ? 'Sì' : 'No'}}</span></p>
    <p>Tipologia sedute <code>seats_types</code>: <span :class="`${isChanged('seats_types') ? ' font-weight-bold':''}`">{{modelValue.seats_types.map(sTypeName).join(', ')}}</span></p>
    <p>N° disponibili <code>available</code>: <span :class="`${isChanged('available') ? ' font-weight-bold':''}`">{{modelValue.available}}</span></p>
    <p>N° usate <code>used</code>: <span :class="`${isChanged('used') ? ' font-weight-bold':''}`">{{modelValue.used}}</span></p>
    <p>Durata in giorni <code>duration</code>: <span :class="`${isChanged('duration') ? ' font-weight-bold':''}`">{{modelValue.duration}}</span></p>
    <p>Prodotto <code>product_id</code>: <a :class="`cursor-pointer${isChanged('product_id') ? ' font-weight-bold':''}`" @click="goToProductPage(modelValue.product_id)">{{displayProductId(modelValue.product_id)}}</a></p>
    <p>Vendita <code>purchase_id</code>: <a :class="`cursor-pointer${isChanged('purchase_id') ? ' font-weight-bold':''}`" @click="goToPurchasePage(modelValue.purchase_id)">{{displayPurchaseId(modelValue.purchase_id)}}</a></p>
    <p>Scadenza condivisa con altre sedute <code>shared_expiration</code>: <span :class="`${isChanged('shared_expiration') ? ' font-weight-bold':''}`">{{modelValue.shared_expiration ? 'Sì' : 'No'}}</span></p>
    <p>Pacchetto sedute principale <code>main_user_seats_id</code>: <a :class="`cursor-pointer${isChanged('main_user_seats_id') ? ' font-weight-bold':''}`" @click="$router.push(`/users/${modelValue.user_id}/seats`)">[modelValue.main_user_seats_id]</a></p>
    <v-card variant="outlined" rounded class="mt-2">
      <v-card-text class="pa-2">
        <h4 class="mt-0 mb-2">Prenotazioni collegate</h4>
        <p v-for="b in bookings">{{formatDate(b.date)}} {{b.calendar_hour?.time}}<span v-if="b.calendar_hour?.name"> ({{b.calendar_hour.name}})</span>: {{sTypeName(b.type)}}</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import {defineComponent, inject, onMounted, type PropType, ref} from 'vue'
import {type Booking, type BookingDisplay, SeatsType, type TopGymLogChangedField, type UserSeat} from "@/models.ts";
import type {Globals} from "@/plugins/globals.ts";
import utils from "@/utils";
import {useRouter} from "vue-router";
import api from "@/api";

export default defineComponent({
  name: "UserSeatCard",
  props : {
    modelValue : {
      type : Object as PropType<UserSeat>,
      required : true
    },
    changedFields : {
      type : Array as PropType<TopGymLogChangedField[]>
    }
  },
  setup(props, ctx) {

    const router = useRouter()
    const globals = inject('globals') as Globals

    const bookings = ref<BookingDisplay[]>([])

    onMounted(async ()=> {
      const res = await api.list<BookingDisplay>('booking', { userseats : props.modelValue._id}, 0,0, '-date')
      bookings.value = res.data ?? []
    })


    return {
      bookings,
      displayUserId(id:string):string {
        const u = globals.users.value.find(u => u._id === id)
        return u ? `[${u._id}] ${u.surname} ${u.name} (${u.email})` : `[${id}] - utente eliminato`
      },
      displayProductId(id?:string):string {
        if(!id) return '-'
        const p = globals.products.value.find(p => p._id === id)
        return p ? `[${p._id}] ${p.title.it}` : `[${id}] - prodotto eliminato`
      },
      displayPurchaseId(id?:string):string {
        if(!id) return '-'
        const p = globals.purchases.value.find(p => p._id === id)
        return p ? `[${p._id}] vendita del ${utils.formatDateTime(p.date)}` : `[${id}] - vendita eliminata`
      },
      displayMainUserSeatsId(id?:string):string {
        if(!id) return '-'
        return `[${id}] pacchetto sedute principale`
      },
      sTypeName(s:SeatsType):string {
        switch (s) {
          case SeatsType.exp:
            return "TopGym experience";
          case SeatsType.corsi:
            return "Sala corsi";
          case SeatsType.opengym:
            return "Open gym";
          case SeatsType.vacu:
            return "Vacu";
        }
        return s
      },
      async goToProductPage(id?:string) {
        if(!id) return
        const p = globals.products.value.find(p => p._id === id)
        if(!p) return
        await router.push(`/kits/${p.kit_id}/products/${id}`)
      },
      async goToPurchasePage(id?:string) {
        if(!id) return
        const p = globals.purchases.value.find(p => p._id === id)
        if(!p) return
        await router.push(`/sells/${id}/view`)
      },
      isChanged(attr:keyof UserSeat):boolean {
        if(!props.changedFields || !props.changedFields.length) return false
        const i = props.changedFields.find(p => p.name === attr)
        return i !== undefined
      },
      formatDate : utils.formatDate,
      formatDateTime : utils.formatDateTime,
    }
  }
})
</script>

<style scoped>
.log-item-detail p {
  font-size: 12px;
  margin-top: 0;
  padding-bottom: 4px;
  margin-bottom: 4px;
  border-bottom: 1px solid #eee;
}

.log-item-detail p:has(> .font-weight-bold) {
  color: #dd0000;
}
.log-item-detail code {
  background-color: #dddddd;
  border-radius: 4px;
  padding: 2px 4px;
}
.log-item-detail a{
  text-decoration: underline;
  color: #f39530;
}
</style>